import * as React from "react";
import { useSelector } from "react-redux";
import { useFormattedMessage } from "../../../sharedComponents/hooks/useFormattedMessage";
import { getEmailOnlyMentions } from "../../selectors/mentions";
import { ProjectOrTask, RootMessageBoardState } from "../../types";

type formattedMessageProps = {
    className?: string;
    text: string;
    projectOrTask?: ProjectOrTask;
};

export const FormattedMessage = React.forwardRef(
    ({ text, className, projectOrTask }: formattedMessageProps, ref: React.RefObject<HTMLDivElement>) => {
        const emailOnlyMentions = useSelector((state: RootMessageBoardState) =>
            getEmailOnlyMentions(state, projectOrTask)
        );
        const [message] = useFormattedMessage(text, emailOnlyMentions);

        return <div ref={ref} className={className} dangerouslySetInnerHTML={{ __html: message }} />;
    }
);
